<template>
    <div>
        <!-- Toolbar -->
        <portal to="portal_toolbar" :order="1">
            <a
                v-if="importData.source.id > 0 && !importData.running"
                :href="$route('brands.product-import.start', {sourceId: importData.source.id})"
                class="btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bolder font-size-sm px-5 my-1">
                <i class="fas fa-redo-alt mr-2"></i>Erneut ausführen
            </a>
        </portal>
        <Card>
            <errors v-if="errors.length"
                    title="Ein Fehler ist aufgetreten"
                    :errors="errors"/>

            <div class="row">
                <div class="col-xl-3">
                    <h2>Produktdatenimport</h2>
                    <table class="table table-borderless table-sm">
                        <tr>
                            <td class="pr-3 font-weight-bold">Gestartet</td>
                            <td>
                                {{ $localDate(importData.created_at) }}, {{ $localTime(importData.created_at) }} Uhr
                            </td>
                        </tr>
                        <tr>
                            <td class="pr-3 font-weight-bold">Datenquelle</td>
                            <td>
                                <data-source :source="importData.source.type"/>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="col-xl-1 col-0"/>
                <div class="col">
                    <div class="row">
                        <div class="col-3" v-for="(name, field) in numberFields">
                            <div class="text-lg">{{ name }}</div>
                            <div class="text-4xl">{{ importData[field] }}</div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <div class="progress h-2em">
                            <div class="progress-bar"
                                 role="progressbar"
                                 :style="`width: ${importData.progress}%`"
                                 :class="{
                                             'progress-bar-striped progress-bar-animated': importData.running,
                                             'bg-danger': errors.length > 0
                                         }"/>
                        </div>
                        <div class="d-flex font-weight-bold mt-2 flex-row">
                            <div>
                                <spinner v-if="importData.running" class="d-inline-block pt-1 mr-2" :size="18"
                                         line-fg-color="#555"/>
                                <span v-else>
                                            <span v-if="importData.total > 0">Abgeschlossen -&nbsp;</span>
                                            <span v-else>Warte auf Daten -&nbsp;</span>
                                        </span>
                            </div>
                            <div :class="{'pt-1': importData.running}">
                                {{ importData.progress }}%
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="itemProblems.length" class="mt-3 bg-white rounded shadow-sm overflow-hidden">
                <div class="table-responsive">
                    <table class="table table-hover table-vertical-center table-head-bg">
                        <thead>
                        <tr>
                            <th>
                                <TableSort field="ean" :value="serverParams.sort" @input="onSortChange">
                                    {{ __('general.ean') }}
                                </TableSort>
                            </th>
                            <th>
                                <TableSort field="type" :value="serverParams.sort" @input="onSortChange">
                                    {{ __('general.type') }}
                                </TableSort>
                            </th>
                            <th>
                                <TableSort field="message" :value="serverParams.sort" @input="onSortChange">
                                    {{ __('general.hint') }}
                                </TableSort>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="problem in itemProblems">
                            <td><span class="text-monospace">{{ problem.ean }}</span></td>
                            <td>
                                <span v-if="problem.type === 'error'" class="text-danger font-weight-bold text-nowrap">
                                    <i class="fas fa-exclamation-triangle mt-1"/> Fehler
                                </span>
                                <span v-else-if="problem.type === 'warning'"
                                      class="text-warning font-weight-bold text-nowrap">
                                    <i class="fas fa-exclamation-circle mt-1"/> Warnung
                                </span>
                                <span v-else>{{ problem.type }}</span>
                            </td>
                            <td>{{ problem.message }}</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card card-body mt-3" v-else>
                <span>Keine Probleme erkannt</span>
            </div>

            <pre v-if="false" style="margin-top: 80px;">{{ importData }}</pre>
        </Card>
    </div>
</template>

<script>
import Errors from '@components/Errors'
import DataSource from '@components/Brand/ProductImport/DataSource'
import Spinner from 'vue-simple-spinner'
import Card from '@components/Cards/Card.vue'
import TableSort from '@components/Table/TableSort.vue'

export default {
    components: {
        TableSort,
        Card,
        Errors,
        DataSource,
        Spinner,
    },

    props: {
        importId: Number,
        importDataInit: Object,
        firebaseUid: String,
    },

    data() {
        return {
            importData: {
                messages: [],
                running: false,
                source: {
                    id: -1,
                    type: '',
                },
            },
            numberFields: {
                read: 'Eingelesen', new: 'Neu', updated: 'Aktualisiert', skipped: 'Übersprungen',
            },
        }
    },

    mounted() {
        this.importData = this.importDataInit
        window.Echo.private('users.' + this.firebaseUid).
            listen('.brand-product-import-' + this.importId, (data) => {
                this.importData = data
            })
    },

    methods: {
        ratio(n) {
            if (this.importData.total === 0) {
                return 0
            }

            return (n * 100 / this.importData.total).toFixed(2)
        },
    },

    computed: {
        errors() {
            let errorMessages = []
            for (let importMessage of this.importData.messages) {
                if (importMessage.type === 'error' && importMessage.ean === null) {
                    errorMessages.push(importMessage.message)
                }
            }
            return errorMessages
        },

        itemProblems() {
            let problems = []
            for (let importMessage of this.importData.messages) {
                if (importMessage.ean) {
                    problems.push(importMessage)
                }
            }
            return problems
        },

        progress() {
            if (this.importData.total === 0) {
                return 0
            }

            return (this.importData.read * 100 / this.importData.total).toFixed(2)
        },
    },
}
</script>
